const slugify = (str: string) =>
    str
        .split(" ")
        .join("-")
        .toLowerCase();

export default slugify;
